/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum EventType {
  SURVEY = 'SURVEY',
  MEDIA = 'MEDIA',
  RECHARGE = 'RECHARGE',
  EXPIRATION = 'EXPIRATION',
  REWARD = 'REWARD',
  QUIZ = 'QUIZ',
  VIDEO = 'VIDEO',
  PDF = 'PDF',
}

export enum PerformedBy {
  SYSTEM = 'SYSTEM',
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum Period {
  MONTHLY = 'MONTHLY',
  QUARTER = 'QUARTER',
  SEMESTER = 'SEMESTER',
}

export enum ClusterType {
  INTENSIVI = 'intensivi',
  REGOLARI = 'regolari',
  MODERATI = 'moderati',
  OCCASIONALI = 'occasionali',
  SOTTO_UTILIZZATORI = 'sotto_utilizzatori',
  INATTIVI = 'inattivi',
}
